<template>
    <section class="mb-3 mb-lg-4" id="paso-4">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="text-uppercase mb-4">{{ $t('bases.subir_foto_perfil') }}</h2>
                </div>
                <div class="col-12">
                    <b-card-text v-if="!esRenovacion || manager.documentacion_obligatoria_bases">
                        <p style="font-size: 19px;">{{ $t('bases.adjuntar_foto_perfil') }}</p>
                        <ul>
                            <li style="font-size: 19px;"><b>{{ $t('bases.foto_perfil') }}</b></li>
                        </ul>
                        <p style="font-size: 19px;">{{ $t('bases.peso_imagenes', {peso: maxFilesize}) }}</p>
                    </b-card-text>
                    <b-card-text v-else>
                        <h4>{{ $t('bases.imagenes_renovacion', {imagen: 'foto de perfil' }) }}</h4>
                    </b-card-text>
                    <Dropzone
                        v-if="url"
                        :url="url"
                        :maxFilesize="maxFilesize"
                        :disabled="loading"
                        @success="vdropzone_success_handler"
                    />
                    <h4 style="font-size: 24px;" v-if="esRenovacion || !manager.documentacion_obligatoria_bases" class="mt-2 text-uppercase">{{ $t('bases.fotos_opcionales', {foto: 'foto de perfil'}) }}</h4>
                    <div class="text-right mt-3">
                        <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-3" :disabled="loading" >
                            <span>{{ $t('formularios.atras') }}</span>
                        </button>
                        <button @click="terminar" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" data-cy="terminar-paso-4" id="terminar-paso-4" :disabled="loading">
                            <span>{{ $t('formularios.continuar') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ["base", "esMovil"],
        data() {
            return {
                formulario: null,
                url: this.config.API_BASE + "/f/guardar-foto-deportista",
                maxFilesize: 20,
                foto_url: '',
                esRenovacion: window.location.href.indexOf("renovar") > -1,
                localData: { ...this.base },
                loading: false
            };
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            vdropzone_success_handler(file, response) {
                this.foto_url = response.url;
            },
            terminar() {
                this.loading = true;

                if (!this.foto_url) {
                    this.$emit("terminado", this.localData);
                    this.loading = false;
                    return;
                }

                let params = {
                    foto_url: this.foto_url,
                    session_id: this.localData.session_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-foto-perfil'), params).then(res => {
                    this.localData.categoria_base.session_id = res.data.session_id;
                    this.$emit("terminado", this.localData);
                }).catch(e => {
                    console.error(e);
                }).finally(() => {
                    this.loading = false;
                });
            },
            volver() {
                this.$emit('volver');
            },
        },
        components: {
            Dropzone
        },
    };
</script>
